import { createSelector } from 'reselect'

const windowSelector = state => state.window
const currentStepSelector = state => state.currentStep

const isConfirmPricingStepEnabledSelector = createSelector(
  [windowSelector, currentStepSelector],
  (window, currentStep) => {
    if (window && st.Media.isMax("sm", window.width)) {
      return true;
    }
    
    return currentStep === 3
  }
)

export default isConfirmPricingStepEnabledSelector



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/selectors/isConfirmPricingStepEnabledSelector.js